import React, { useState, useEffect } from 'react';
import '../App.css';

function EditBranchModal({ isOpen, onClose, onUpdateBranch, branchData, setBranchData }) {
  const headquartersOptions = [
    "서울본부", "남서울본부", "인천본부", "경기북부본부", "경기본부", 
    "강원본부", "충북본부", "대전세종충남본부", "전북본부", "광주전남본부", 
    "대구본부", "경북본부", "부산울산본부", "경남본부", "제주본부"
  ];

  const branchMap = {
    "서울본부": ["서울본부직할", "동대문중랑지사", "서대문은평지사", "강북성북지사", "광진성동지사", "마포용산지사", "노원도봉지사"],
    "남서울본부": ["남서울본부직할", "강서양천지사", "관악동작지사", "강동송파지사", "구로금천지사", "강남지사", "서초지사"],
    "인천본부": ["인천본부직할", "남인천지사", "부천지사", "김포지사", "제물포지사", "서인천지사", "시흥지사", "강화지사", "영종지사", "백령지사"],
    "경기북부본부": ["경기북부본부직할", "고양지사", "파주지사", "구리지사", "양평지사", "포천지사", "남양주지사", "동두천지사", "가평지사", "연천지사"],
    "경기본부": ["경기본부직할", "안양군포의왕지사", "안산지사", "성남지사", "오산지사", "평택지사", "화성지사", "광주지사", "서수원지사", "서용인지사", "안성지사", "이천지사", "서평택지사", "동용인지사", "여주지사", "하남지사", "광명지사"],
  };

  const [branchOptions, setBranchOptions] = useState([]);

  useEffect(() => {
    if (branchData && branchData.headquarters) {
      setBranchOptions(branchMap[branchData.headquarters] || []);
    } else {
      setBranchOptions([]);
    }
  }, [branchData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBranchData(prev => ({ ...prev, [name]: value }));
  };

  const handleHeadquartersChange = (e) => {
    const { value } = e.target;
    setBranchData(prev => ({
      ...prev,
      headquarters: value,
      name: ''
    }));
  };

  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: function(data) {
        setBranchData(prev => ({ ...prev, address: data.address }));
      }
    }).open();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>×</button>
        <h1>지사 정보 수정</h1>
        <form onSubmit={onUpdateBranch} className="branch-form-modal">
          <div className="form-group">
            <label>본부</label>
            <select name="headquarters" value={branchData.headquarters} onChange={handleHeadquartersChange} required>
              <option value="">본부를 선택하세요</option>
              {headquartersOptions.map(hq => <option key={hq} value={hq}>{hq}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>지사</label>
            <select name="name" value={branchData.name} onChange={handleInputChange} required>
              <option value="">지사를 선택하세요</option>
              {branchOptions.map(branch => <option key={branch} value={branch}>{branch}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>대표자</label>
            <input type="text" name="representative" value={branchData.representative} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>주소</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="text"
                name="address"
                value={branchData.address}
                readOnly
                placeholder="주소 검색 버튼을 클릭하세요"
              />
              <button type="button" className="action-button" onClick={handleAddressSearch}>
                주소 검색
              </button>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-button">수정하기</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditBranchModal;
